import { derived, writable } from "svelte/store";
const href = writable(window.location.href);
const originalPushState = history.pushState;
const originalReplaceState = history.replaceState;
const updateHref = () => href.set(window.location.href);
history.pushState = function () {
    originalPushState.apply(this, arguments);
    updateHref();
};
history.replaceState = function () {
    originalReplaceState.apply(this, arguments);
    updateHref();
};
window.addEventListener("popstate", updateHref);
window.addEventListener("hashchange", updateHref);
export function setQueryStringParameter(name, value, append = false) {
    const params = new URLSearchParams(window.location.search);
    if (append) {
        params.append(name, value);
    }
    else {
        params.set(name, value);
    }
    if (name != 'p') {
        params.set('p', '1');
    }
    if (['startDate', 'endDate'].includes(name)) { // TODO: Should probably ensure startDate comes BEFORE endDate
        if (name === 'startDate' && !params.has('endDate')) {
            params.set("endDate", `${value.slice(0, 10)}T23:59:59`);
        }
        if (name === 'endDate' && !params.has('startDate')) {
            params.set('startDate', `${value.slice(0, 10)}T00:00:00`);
        }
    }
    window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
}
export function replaceQueryParameter(oldParams, newParam, value) {
    const params = new URLSearchParams(window.location.search);
    if (Array.isArray(oldParams)) {
        oldParams.forEach(param => {
            params.delete(param);
        });
    }
    else {
        params.delete(oldParams);
    }
    params.set(newParam, value);
    window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
}
export function deleteQueryStringParameter() {
    const params = new URLSearchParams(window.location.search);
    params.delete(window.location.search);
    window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}`));
}
export function deleteSearchQueryStringParameter(name, value) {
    const params = new URLSearchParams(window.location.search);
    // @ts-ignore
    params.delete(name, value);
    window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
}
export function deleteAllSearchQueryStringParameter(name) {
    const params = new URLSearchParams(window.location.search);
    params.delete(name);
    window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
}
export function deleteWhenSearchQueryStringParameter(start, end) {
    const params = new URLSearchParams(window.location.search);
    // TODO: add the value parameter once typescript is updated
    params.delete(start);
    params.delete(end);
    window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
}
export const url = derived(href, $href => new URL($href));
